import request from '../index.js'

// 积分管理API - 连接真实后端API
export const creditApi = {
  // 获取用户积分列表
  getUserCredits(params) {
    const { page = 1, pageSize = 10, userId, creditTypeId } = params || {}
    const queryParams = { page, size: pageSize }
    if (userId) queryParams.userId = userId
    if (creditTypeId) queryParams.creditTypeId = creditTypeId
    
    return request({
      url: '/admin/credits/users',
      method: 'get',
      params: queryParams
    })
  },

  // 获取积分交易记录
  getTransactions(params) {
    const { page = 1, pageSize = 10, userId, creditTypeId, transactionType } = params || {}
    const queryParams = { page, size: pageSize }
    if (userId) queryParams.userId = userId
    if (creditTypeId) queryParams.creditTypeId = creditTypeId
    if (transactionType) queryParams.transactionType = transactionType
    
    return request({
      url: '/admin/credits/transactions',
      method: 'get',
      params: queryParams
    })
  },

  // 获取积分类型列表
  getCreditTypes() {
    return request({
      url: '/credit-types',
      method: 'get'
    })
  },

  // 调整用户积分
  adjustCredit(data) {
    return request({
      url: '/admin/credits/adjust',
      method: 'post',
      data
    })
  },

  // 获取积分统计
  getCreditStats() {
    return request({
      url: '/admin/credits/stats',
      method: 'get'
    })
  }
}

export default creditApi
